<div class="archive-title">
  Archive
</div>
<div *ngFor="let post of posts">
  <div class="post-title">
    {{ post.title }}
  </div>
  <div class="post-subtitle">
    {{ post.subtitle }}
  </div>
  <div>
    {{ post.createdAt | date }}
  </div>
</div>